import { makeStyles, TextField } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  field: {
    '& .MuiInputBase-input': {
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },

      '&[type=number]': {
        '-moz-appearance': 'textfield',
      },
    },
  },
}));

type NumberValueFieldProps = Omit<
  React.ComponentProps<typeof TextField>,
  'type'
>;

export default function NumberValueField(props: NumberValueFieldProps) {
  const classes = useStyles();
  return <TextField type="number" className={classes.field} {...props} />;
}
